export default "__VITE_ASSET__BktfHGwb__"